export const tariffOptionsSessions = [
    { id: '1', name: '1 (standart)' },
    { id: '2', name: '2 (first_hour_free_old)' },
    { id: '3', name: '3 (special)' },
    { id: '4', name: '4 (first_hour_free_2)' },
    { id: '5', name: '5 (first_hour_free)' },
    { id: '6', name: '6 (29_per_day_partner)' },
    { id: '7', name: '7 (airport)' },
    { id: '8', name: '8 (crimea)' },
    { id: '9', name: '9 (sheregesh)' },
    { id: '10', name: '10 (30min_free)' },
    { id: '11', name: '11 (Swim_pool)' },
    { id: '12', name: '12 (new100)' },
    { id: '13', name: '13 (tele2_special)' },
    { id: '14', name: '14 (new_standart_def)' },
    { id: '15', name: '15 (first_session_new_def)' },
    { id: '16', name: '16 (Crimea_VIP)' },
    { id: '17', name: '17 (Crimea_Guest)' },
    { id: '18', name: '18 (Moscow Central Ring)' },
    { id: '19', name: '19 (for_tele2_premium)' },
    { id: '20', name: '20 (for_tele2_sub)' },
    { id: '21', name: '21 (exhibition_2h_free)' },
    { id: '22', name: '22 (exhibition_3h_free)' },
    { id: '23', name: '23 (simple_daily)' },
    { id: '24', name: '24 (15min_free_RU_&_UZ)' },
    { id: '25', name: '25 (100hour_200day)' },
    { id: '26', name: '26 (30min_free_100_daily)' },
    { id: '27', name: '27 (2023_first_session_tariff)' },
    { id: '28', name: '28 (2023_ret_session_tariff)' },
    { id: '29', name: '29 (30min_free_1123)' },
    { id: '30', name: '30 (Tomsk1_1123)' },
    { id: '31', name: '31 (Tomsk2_1123)' },
    { id: '32', name: '32 (Siberia1_70_130)' },
    { id: '33', name: '33 (Siberia2_130)' },
    { id: '34', name: '34 (special_limited)' },
    { id: '35', name: '35 (Uz2)' },
    { id: '36', name: '36 (MTS_office)' },
    { id: '37', name: '37 (Metropolitan)' },
    { id: '38', name: '38 (Regional)' },
    { id: '39', name: '39 (kz_249_599_848)' },
    { id: '40', name: '40 (default_IL)' },
    { id: '41', name: '41 (Kuper1)' },
    { id: '42', name: '42 (default_+5_IL)' },
    { id: '43', name: '43 (promo_ru)' },
    { id: '44', name: '44 (10+30AED_uae_only)' },
    { id: '45', name: '45 (20min_free_10+30AED_uae_only)' },
    { id: '46', name: '46 (UAE_2days_0.5)' },
    { id: '47', name: '47 (UAE_5AED)' },
    { id: '48', name: '48 (Kaspi_1490)' },
    { id: '49', name: '49 (KZ_1h549KZT_23h849_1d1398)' },
    { id: '50', name: '50 (KZ_1h590KZT_23h900_1d1490)' },
    { id: '51', name: '51 (KZ_1h599KZT_23h999_1d1598)' },
    { id: '52', name: '52 (tariff_52_ru)' },
    { id: '53', name: '53 (tariff_53_ru)' },
    { id: '54', name: '54 (tariff_54_ru)' },
    { id: '55', name: '55 (tariff_55_ru)' },
    { id: '56', name: '56 (Kaspi_590)' },
];

export const tariffOptionsLocations = [
    { id: '1', name: '1 (standart)' },
    { id: '2', name: '2 (first_hour_free_old)' },
    { id: '3', name: '3 (special)' },
    { id: '4', name: '4 (first_hour_free_2)' },
    { id: '5', name: '5 (first_hour_free)' },
    { id: '6', name: '6 (29_per_day_partner)' },
    { id: '7', name: '7 (airport)' },
    { id: '8', name: '8 (crimea)' },
    { id: '9', name: '9 (sheregesh)' },
    { id: '10', name: '10 (30min_free)' },
    { id: '11', name: '11 (Swim_pool)' },
    { id: '12', name: '12 (new100)' },
    { id: '14', name: '14 (new_standart_def)' },
    { id: '15', name: '15 (first_session_new_def)' },
    { id: '16', name: '16 (Crimea_VIP)' },
    { id: '17', name: '17 (Crimea_Guest)' },
    { id: '18', name: '18 (Moscow Central Ring)' },
    { id: '21', name: '21 (exhibition_2h_free)' },
    { id: '22', name: '22 (exhibition_3h_free)' },
    { id: '23', name: '23 (simple_daily)' },
    { id: '24', name: '24 (15min_free_RU_&_UZ)' },
    { id: '25', name: '25 (100hour_200day)' },
    { id: '26', name: '26 (30min_free_100_daily)' },
    { id: '27', name: '27 (2023_first_session_tariff)' },
    { id: '28', name: '28 (2023_ret_session_tariff)' },
    { id: '29', name: '29 (30min_free_1123)' },
    { id: '30', name: '30 (Tomsk1_1123)' },
    { id: '31', name: '31 (Tomsk2_1123)' },
    { id: '32', name: '32 (Siberia1_70_130)' },
    { id: '33', name: '33 (Siberia2_130)' },
    { id: '33', name: '35 (Uz2)' },
    { id: '36', name: '36 (MTS_office)' },
    { id: '37', name: '37 (Metropolitan)' },
    { id: '38', name: '38 (Regional)' },
    { id: '39', name: '39 (kz_249_599_848)' },
    { id: '40', name: '40 (default_IL)' },
    { id: '41', name: '41 (Kuper1)' },
    { id: '42', name: '42 (default_+5_IL)' },
    { id: '43', name: '43 (promo_ru)' },
    { id: '44', name: '44 (10+30AED_uae_only)' },
    { id: '45', name: '45 (20min_free_10+30AED_uae_only)' },
    { id: '46', name: '46 (UAE_2days_0.5)' },
    { id: '47', name: '47 (UAE_5AED)' },
    { id: '48', name: '48 (Kaspi_1490)' },
    { id: '49', name: '49 (KZ_1h549KZT_23h849_1d1398)' },
    { id: '50', name: '50 (KZ_1h590KZT_23h900_1d1490)' },
    { id: '51', name: '51 (KZ_1h599KZT_23h999_1d1598)' },
    { id: '52', name: '52 (tariff_52_ru)' },
    { id: '53', name: '53 (tariff_53_ru)' },
    { id: '54', name: '54 (tariff_54_ru)' },
    { id: '55', name: '55 (tariff_55_ru)' },
    { id: '56', name: '56 (Kaspi_590)' },
];

export const tariffSpecialOptions = [
    { id: '3', name: '3 (special)' },
    { id: '6', name: '6 (29_per_day_partner)' },
    { id: '34', name: '34 (special_limited)' },
];
